export default __webpack_public_path__ + "static/media/omega-black.778fc6a9.svg";